var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[(_vm.meta === 'list')?_c('div',{staticClass:"productListBg"},[_c('div',{staticClass:"textSize28 custom"},[_vm._v(_vm._s(_vm.currentCategory))])]):_vm._e(),(_vm.meta === 'list')?_c('TabsCategory'):_vm._e(),_c('router-view'),_c('div',{staticClass:"wrapper noticeList"},[_c('NoticeList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }